/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import {
  saveTransportationField,
  saveTransportationDateField
} from '../api/setFormData'
const initialState = {
  // initialValues
}

export default function TransportInfoReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_TRANSPORTATION': {
      return Object.assign({}, state, { ...action.payload })
    }
    case 'INITIALIZE_VALUES_CARRIER_CODE': {
      return Object.assign({}, state, { ...action.payload })
      
    }
    case 'UPDATE_TRANSPORTATION_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }
    case 'UPDATE_TRANSPORTATION_DATE': {
      let newObj = Object.assign({}, state[action.object])
      newObj.epochs = action.payload
      return Object.assign({}, state, { [action.object]: newObj })
    }
    case 'SAVE_TRANSPORTATION_FIELD': {
      saveTransportationField(action.field, action.payload)
      return state
    }
    case 'SAVE_TRANSPORTATION_DATE_FIELD': {
      return (
        saveTransportationDateField(
          [action.field],
          action.payload,
          state.shipId
        ).then(response => console.log(response)),
        Object.assign({}, state, {
          [action.field]: Object.assign({}, ...[action.field], {
            epochs: action.payload
          })
        })
      )
    }

    case 'INITIALIZE_SHIPID': {
      return Object.assign({}, state, { shipId: action.payload })
    }
    case 'UPDATE_TRANSPORTATION_INFO_WARNING': {
      return Object.assign({}, state, { warning: action.warnings })
    }
    default:
      return state
  }
}
